<div class="tool-panel"  name="tool-selector">
  <div matTooltip="{{ getTooltipMessage(tools.MEASURE_POLYGON) }}" matTooltipPosition="left">
    <button
      id="polygon-button"
      type="button"
      class="mat-icon-toggle-button"
      matIconButton
      [disabled]="toolsDisabled"
      (click)="selectTool(tools.MEASURE_POLYGON)"
      [class.selected]="isSelected(tools.MEASURE_POLYGON)">
      <mat-icon svgIcon="poly"></mat-icon>
    </button>
  </div>

  <div matTooltip="{{ getTooltipMessage(tools.MEASURE_AREA) }}" matTooltipPosition="left">
    <button
      id="square-button"
      type="button"
      matIconButton
      class="mat-icon-toggle-button"
      [disabled]="toolsDisabled"
      (click)="selectTool(tools.MEASURE_AREA)"
      [class.selected]="isSelected(tools.MEASURE_AREA)">
      <mat-icon svgIcon="box"></mat-icon>
    </button>
  </div>

  <div matTooltip="{{ getTooltipMessage(tools.MEASURE_CIRCLE) }}" matTooltipPosition="left">
    <button
      type="button"
      matIconButton
      class="mat-icon-toggle-button"
      [disabled]="toolsDisabled"
      (click)="selectTool(tools.MEASURE_CIRCLE)"
      [class.selected]="isSelected(tools.MEASURE_CIRCLE)">
      <mat-icon svgIcon="circle"></mat-icon>
    </button>
  </div>

  <div matTooltip="{{ getTooltipMessage(tools.MEASURE_LINE) }}" matTooltipPosition="left">
    <button
      id="line-button"
      type="button"
      matIconButton
      class="mat-icon-toggle-button"
      [disabled]="toolsDisabled"
      (click)="selectTool(tools.MEASURE_LINE)"
      [class.selected]="isSelected(tools.MEASURE_LINE)">
      <mat-icon svgIcon="line"></mat-icon>
    </button>
  </div>
  <div matTooltip="{{ getTooltipMessage(tools.MEASURE_HEIGHT) }}" matTooltipPosition="left">
    <button
      id="height-button"
      type="button"
      matIconButton
      class="mat-icon-toggle-button"
      (click)="selectTool(tools.MEASURE_HEIGHT)"
      [class.selected]="isSelected(tools.MEASURE_HEIGHT)"
      [disabled]="heightToolDisabled">
      <mat-icon svgIcon="height"></mat-icon>
    </button>
  </div>
  <div *ngIf="mode3D" matTooltip="{{ getTooltipMessage(tools.RELATIVE_MEASURE_POINT) }}" matTooltipPosition="left">
    <button
      id="relative-point-button"
      [disabled]="relativeHeightToolDisabled"
      type="button"
      matIconButton
      class="mat-icon-toggle-button"
      (click)="selectTool(tools.RELATIVE_MEASURE_POINT)"
      [class.selected]="isSelected(tools.RELATIVE_MEASURE_POINT)">
      <mat-icon>control_point_duplicated</mat-icon>
    </button>
  </div>
  <div matTooltip="{{ getTooltipMessage(tools.MEASURE_POINT) }}" matTooltipPosition="left">
    <button
      id="point-button"
      type="button"
      matIconButton
      class="mat-icon-toggle-button"
      [disabled]="toolsDisabled"
      (click)="selectTool(tools.MEASURE_POINT)"
      [class.selected]="isSelected(tools.MEASURE_POINT)">
      <mat-icon>control_point</mat-icon>
    </button>
  </div>

  <div *ngIf="debugMode" matTooltip="DTM Point" matTooltipPosition="left">
    <button
      id="point-dtm-button"
      type="button"
      matIconButton
      class="mat-icon-toggle-button"
      [disabled]="toolsDisabled"
      (click)="selectTool(tools.MEASURE_POINT_3D)"
      [class.selected]="isSelected(tools.MEASURE_POINT_3D)">
      <mat-icon>control_point_duplicate</mat-icon>
    </button>
  </div>

  <div *ngIf="debugMode && mode3D && status3D !== 'stop'" matTooltip="DSM Point" matTooltipPosition="left">
    <button
      id="point-survey-button"
      [disabled]="status3D !== 'finished' && toolsDisabled"
      type="button"
      matIconButton
      class="mat-icon-toggle-button"
      (click)="selectTool(tools.MEASURE_POINT_SURVEY)"
      [class.selected]="isSelected(tools.MEASURE_POINT_SURVEY)">
      <mat-icon>height</mat-icon>
    </button>
  </div>
  <mat-divider></mat-divider>
  <div matTooltip="{{ getInfoTooltip() }}" matTooltipPosition="left">
    <button
          cdkOverlayOrigin #triggerEditAction="cdkOverlayOrigin"
      id="info-button"
      type="button"
      class="mat-icon-toggle-button"
      matIconButton
      [disabled]="!existFeatures()"
      (click)="toggleSelection()"
      [class.selected]="selectActionEnabled">
      <mat-icon class="whiteIcon">info_outline</mat-icon>
    </button>
  </div>
    <button
            id="move-features-button"
            type="button"
            class="mat-icon-toggle-button"
            matIconButton
            [disabled]="!existFeatures()"
            (click)="toggleDrag()"
            [class.selected]="dragActionEnabled"
            matTooltip="{{ !editActionEnabled ? 'Move feature' : null }}"
            matTooltipPosition="left">
        <mat-icon svgIcon="drag"></mat-icon>
    </button>

  <button
    id="edit-features-button"
    type="button"
    class="mat-icon-toggle-button"
    matIconButton
    [disabled]="!existFeatures()"
    (click)="toggleEdit()"
    [class.selected]="editActionEnabled"
    matTooltip="{{ !editActionEnabled ? 'Edit feature' : null }}"
    matTooltipPosition="left">
    <mat-icon svgIcon="edit"></mat-icon>
  </button>
  <button
    cdkOverlayOrigin #triggerEditColor="cdkOverlayOrigin"
    id="color-fill-button"
    class="mat-icon-toggle-button"
    type="button"
    matIconButton
    [disabled]="!existFeatures()"
    (click)="selectColorFill()"
    [class.selected]="editColorActionEnabled"
    matTooltip="{{ !editActionEnabled ? 'Edit color' : null }}"
    matTooltipPosition="left">
    <mat-icon svgIcon="color_fill"></mat-icon>
  </button>
  <div matTooltip="Undo shape" matTooltipPosition="left">
    <button
      id="undo-shape-button"
      class="mat-icon-toggle-button"
      type="button"
      matIconButton
      [disabled]="!existFeatures()"
      (click)="undoShape()">
      <mat-icon svgIcon="undo"></mat-icon>
    </button>
  </div>
  <div matTooltip="Remove selected feature" matTooltipPosition="left">
    <button
      id="remove-selected-button"
      class="mat-icon-toggle-button"
      type="button"
      matIconButton
      [disabled]="!isFeatureSelected()"
      (click)="deleteSelectedFeature()">
      <mat-icon>delete</mat-icon>
    </button>
  </div>
  <div matTooltip="Clear workspace" matTooltipPosition="left">
    <button
      id="clear-button"
      type="button"
      class="mat-icon-toggle-button"
      matIconButton
      [disabled]="!existFeatures()"
      (click)="clearWorkspace()">
      <mat-icon svgIcon="clear"></mat-icon>
    </button>
  </div>
  <div matTooltip="Export layer or feature" matTooltipPosition="left">
    <button
      id="export-layer"
      type="button"
      class="mat-icon-toggle-button"
      matIconButton
      [disabled]="!existFeatures()"
      (click)="showExportMeasurementLayerDialog()"
      [class.selected]="isExportLayerDialogOpen">
      <mat-icon>get_app</mat-icon>
    </button>
  </div>
</div>
<ng-template
        cdkConnectedOverlay
        [cdkConnectedOverlayOrigin]="triggerEditColor"
        [cdkConnectedOverlayOpen]="editColorActionEnabled"
        [cdkConnectedOverlayPositions]="[
    {
      originX: 'start',
      originY: 'top',
      overlayX: 'end',
      overlayY: 'top'
    }
  ]"
        (detach)="editColorActionEnabled = false"

>
    <lib-color-swatch-picker
      [triggerHidden]="true"
      alphaChannel="forced"
      outputFormat="rgba"
      [color]="currentColor()"
      (colorChange)="currentColor.set($event)"
      (colorApply)="applyColor($event)"
      (colorCancel)="cancelColor()" />
</ng-template>
<ng-template
        cdkConnectedOverlay
        [cdkConnectedOverlayOrigin]="triggerEditAction"
        [cdkConnectedOverlayOpen]="selectActionEnabled"
        [cdkConnectedOverlayPositions]="[
    {
      originX: 'start',
      originY: 'top',
      overlayX: 'end',
      overlayY: 'top'
    }
  ]"
        (detach)="selectActionEnabled = false"

>
    <app-measurement-info
            [mode3D]="mode3D"
            [status3D]="status3D"
            [oblique]="oblique"
            [inside]="insideDsm"
            [debugMode]="viewerService.developerTools$ | async"
            *ngIf="selectActionEnabled"
            [measuresSelected]="viewerService.measuresSelected$ | async"></app-measurement-info>
</ng-template>